import React from 'react';

function ServicesSection() {
  const specialities = [
    { name: "Depression & Anxiety", icon: "🌱" },
    { name: "Relationship Issues", icon: "🤝" },
    { name: "Psychological Disorders", icon: "🧠" },
    { name: "Attachment Styles", icon: "🔗" },
    { name: "Drug Abuse Recovery", icon: "🛡️" },
    { name: "Sexual Issues", icon: "❤️‍🩹" },
    { name: "Grief & Bereavement", icon: "🕊️" },
    { name: "Wellness & Mindfulness", icon: "✨" }
  ];

  return (
    <section className="py-24 px-6 md:px-16 lg:px-24 bg-[#FDFBF7]">
      <div className="max-w-7xl mx-auto">
        <header className="text-center mb-16">
          <span className="text-xs font-black uppercase tracking-[0.3em] text-ocean-teal">Areas of Expertise</span>
          <h2 className="text-4xl md:text-5xl font-serif font-bold text-deep-charcoal mt-4">How I Can Help You</h2>
        </header>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
          {specialities.map((item, index) => (
            <div key={index} className="bg-white p-8 rounded-[2rem] shadow-sm hover:shadow-xl transition-all duration-500 border border-gray-50 hover:border-ocean-teal/30 group text-center cursor-default transform hover:-translate-y-1">
              <div className="text-4xl mb-4 group-hover:scale-110 transition-transform duration-300">{item.icon}</div>
              <h3 className="text-sm font-bold text-deep-charcoal/90 uppercase tracking-wide leading-relaxed">{item.name}</h3>
            </div>
          ))}
        </div>

        <div className="mt-20 bg-deep-charcoal text-white p-8 md:p-12 rounded-[3rem] text-center max-w-4xl mx-auto relative overflow-hidden shadow-2xl">
          <div className="absolute top-[-50%] left-[-10%] w-64 h-64 bg-ocean-teal opacity-20 rounded-full blur-3xl"></div>
          <h3 className="text-sm font-black uppercase tracking-[0.3em] text-ocean-teal mb-4 relative z-10">Therapeutic Modalities</h3>
          <p className="text-lg md:text-xl font-serif text-white/90 leading-relaxed relative z-10">
            Cognitive Behavioural Therapy (CBT) • Life Coaching • Grief and Bereavement Management • Attachment Style Therapy
          </p>
        </div>
      </div>
    </section>
  );
}

export default ServicesSection;